import { DeliveryNoteStatusEnum } from 'commons/enums';

export const DELIVERY_NOTE_PRINTED_STATUS_MAP: Partial<
  Record<DeliveryNoteStatusEnum, DeliveryNoteStatusEnum>
> = {
  [DeliveryNoteStatusEnum.READY_PRINT]: DeliveryNoteStatusEnum.PRINTED,
  [DeliveryNoteStatusEnum.PRINTED]: DeliveryNoteStatusEnum.PRINTED,
  [DeliveryNoteStatusEnum.READY_REPRINT]: DeliveryNoteStatusEnum.REPRINTED,
  [DeliveryNoteStatusEnum.REPRINTED]: DeliveryNoteStatusEnum.REPRINTED,
};

export const PRINTABLE_DELIVERY_NOTE_STATUSES = Object.keys(
  DELIVERY_NOTE_PRINTED_STATUS_MAP,
) as DeliveryNoteStatusEnum[];
